import React from 'react';
import { connect } from 'react-redux';

import { useBreadcrumbs } from '../../hooks';
import Settings from './Settings';

const createBreadcrumbs = () => [{ title: 'Settings' }];

const SettingsIndex = ({ userId, section, dispatch }) => {
  useBreadcrumbs(createBreadcrumbs, []);

  // useEffect(() => {
  //   dispatch(loadUserData());
  // }, [userId, dispatch]);

  return <Settings userId={userId} section={section} />;
};

const mapStateToProps = state => ({
  userId: state.login.email,
});
export default connect(mapStateToProps)(SettingsIndex);
